import { HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError, switchMap, filter, take } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '../../features/auth/services/auth.service';
import { LoaderService } from '../../shared/services/loader.service';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const loaderService = inject(LoaderService);
  const token = authService.getToken();

  // Si es una petición de refresh, no interceptar
  if (req.url.includes('/login/refresh')) {
    return next(req);
  }

  // Verificar si el token está expirado y si se puede renovar
  if (token && authService.isTokenExpired() && authService.canRefreshToken()) {
    return authService.refreshAccessToken().pipe(
      switchMap((newToken) => {
        const newReq = req.clone({
          setHeaders: { Authorization: newToken }
        });
        return next(newReq);
      }),
      catchError((error) => {
        loaderService.hide();
        authService.logoutAndRedirect();
        return throwError(() => error);
      })
    );
  }

  // Si no hay token o no se puede renovar y está expirado
  if (token && authService.isTokenExpired() && !authService.canRefreshToken()) {
    loaderService.hide();
    authService.logoutAndRedirect();
    return throwError(() => new Error('Token expired'));
  }

  const clonedReq = token ? req.clone({
    setHeaders: { Authorization: token }
  }) : req;

  return next(clonedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && authService.canRefreshToken()) {
        return authService.refreshAccessToken().pipe(
          switchMap((newToken) => {
            const newReq = req.clone({
              setHeaders: { Authorization: newToken }
            });
            return next(newReq);
          }),
          catchError((refreshError) => {
            loaderService.hide();
            authService.logoutAndRedirect();
            return throwError(() => refreshError);
          })
        );
      } else if (error.status === 401) {
        loaderService.hide();
        authService.logoutAndRedirect();
      }
      return throwError(() => error);
    })
  );
}
